var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',_vm._g(_vm._b({ref:"snackbar",attrs:{"timeout":_vm.timeout,"color":_vm.color},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},'v-snackbar',_vm.$attrs,false),_vm.$listeners),[(_vm.icon)?_c('v-icon',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(" "+_vm._s(_vm.message)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }